import { UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { ESProductCatalogSearch } from '../../../modules/catalogs/products/product-catalog-es.types';
import { getCatalogProductsPageKey } from './catalogProducts.keys';
import { fetchCatalogProductsPage } from './catalogProducts.repository';
import { UseCatalogProductsPageParams } from './catalogProducts.types';

export const useCatalogProductsPage = (params: UseCatalogProductsPageParams) => {
  const {
    catalogId,
    contextParams,
    sortParams,
    groupParams,
    filters,
    customerIds,
    gridDataInclude,
    page,
    enabled,
  } = params;

  const queryKey: UseDataQueryKey = getCatalogProductsPageKey({
    catalogId,
    contextParams,
    sortParams,
    groupParams,
    filters,
    customerIds,
    gridDataInclude,
    page,
  });

  return useDataQuery<ESProductCatalogSearch[]>(
    {
      queryKey,
      queryFn: () => fetchCatalogProductsPage(params),
    },
    { enabled },
  );
};
